import { IRequiredEquipment } from '@ifit/gateway-workout-store';

export const timeRanges = ['0-1199'];

export const targetAreas = [
  'Abs',
  'Arms',
  'Back',
  'Chest',
  'Core',
  'Glutes',
  'Legs',
  'Shoulders',
  'Total Body',
  'Upper Body',
];

export const requiredEquipment = [
  'Dumbbells',
  'Mat',
  'Resistance Bands',
  'Kettlebell',
  'Barbell',
  'Medicine Ball',
  'Blocks',
  'Barre',
  'Mini Bands',
];

export const locations = [
  'Beach',
  'City',
  'Desert',
  'Forest',
  'Landmarks',
  'Mountains',
  'Savannahs',
  'Studio',
  'Waterfront',
];

export const equipment = Object.values(IRequiredEquipment) as any;

export const timeRangesFiltersMap = {
  Treadmill: 'timeRanges',
  Elliptical: 'timeRanges',
  Bike: 'timeRanges',
  Rower: 'timeRanges',
  Strength: 'timeRanges',
  Stepper: 'timeRanges',
  Strider: 'timeRanges',
  InclineTrainer: 'timeRanges',
};

export const equipmentFiltersMap = {
  Treadmill: 'locationTypes',
  Elliptical: 'locationTypes',
  Bike: 'locationTypes',
  Rower: 'locationTypes',
  Strength: 'targetAreas',
  Stepper: 'locationTypes',
  Strider: 'locationTypes',
  InclineTrainer: 'locationTypes',
};

export const vaultEquipmentFiltersMap = {
  Strength: 'requiredEquipment',
  Bike: 'requiredEquipment',
};

export const equipmentOptionsMap = {
  timeRanges,
  locationTypes: locations,
  targetAreas,
  requiredEquipment,
};
